/** Pads the value with a given string to a given length from the start (left). */
export function padNumberStart(value, digits, fillString) {
  return String(value).padStart(digits, fillString);
}
//# sourceMappingURL=padNumberStart.js.map